// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";
import Navigation from "./partials/navigation";
import Carousel from "./partials/carousel";
import OfferLessonFilters from "./partials/offer-lesson-filters";
import HeroScroll from "./partials/hero-scroll";
import HeroHeaderAngle from "./partials/hero-header-angle";
import LessonRegistrationForm from "./partials/lesson-registration-form";
import MyCosmoMenu from "./partials/my-cosmo-menu";
import MyCosmoFinalizeTrial from "./partials/my-cosmo-finalize-trial";
import MyCosmoChildDelete from "./partials/my-cosmo-child-delete";
import PrintPage from "./partials/print-page";

window.initDom = ($wrapper) => {
    console.debug($wrapper, 'init');
    $wrapper.querySelectorAll('[data-site-header]').forEach($el => new Navigation($el));
    $wrapper.querySelectorAll('.hero-header-block, .location-detail-block__hero, .offer-detail-block__hero').forEach($el => new HeroHeaderAngle($el));
    $wrapper.querySelectorAll('[data-hero-scroll]').forEach($el => new HeroScroll($el));
    $wrapper.querySelectorAll('[data-gallery-carousel]').forEach($el => new Carousel($el));
    $wrapper.querySelectorAll('[data-offer-lesson-filters]').forEach($el => new OfferLessonFilters($el));
    $wrapper.querySelectorAll('[data-lesson-registration-form]').forEach($el => new LessonRegistrationForm($el));
    openTargetRegistrationPanel();
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    $wrapper.querySelectorAll('[data-my-cosmo-sidebar]').forEach($el => new MyCosmoMenu($el));
    $wrapper.querySelectorAll('[data-my-cosmo-finalize-dialog]').forEach($el => new MyCosmoFinalizeTrial($el));
    $wrapper.querySelectorAll('[data-my-cosmo-child-delete-dialog]').forEach($el => new MyCosmoChildDelete($el));
    $wrapper.querySelectorAll('[data-print-page]').forEach($el => new PrintPage($el));
    $wrapper.querySelectorAll('[data-hide-on-error]').forEach($el => hideOnError($el));
    applyMediaFocalPoints($wrapper);
    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
}

(function() {
    window.initDom(document);
})();

function openTargetRegistrationPanel() {
    const hash = window.location.hash ? window.location.hash.substring(1) : '';
    const $panel = hash ? document.getElementById(hash) : null;

    if (!$panel || !$panel.matches('[data-lesson-registration-panel]')) {
        return;
    }

    $panel.open = true;
    $panel.scrollIntoView({block: 'center'});
}

function hideOnError($el) {
    if ($el.complete && $el.naturalWidth === 0) {
        $el.hidden = true;
        return;
    }

    $el.addEventListener('error', () => {
        $el.hidden = true;
    }, {once: true});
}

function applyMediaFocalPoints($wrapper) {
    const selector = '[data-focal-position], [data-background-image]';
    const $items = [];

    if ($wrapper.matches && $wrapper.matches(selector)) {
        $items.push($wrapper);
    }

    $items.push(...$wrapper.querySelectorAll(selector));

    $items.forEach($el => {
        const focalPosition = $el.getAttribute('data-focal-position');
        const focalProperty = $el.getAttribute('data-focal-property') || 'object-position';
        const backgroundImage = $el.getAttribute('data-background-image');

        if (backgroundImage) {
            $el.style.backgroundImage = `url("${backgroundImage.replace(/"/g, '\\"')}")`;
        }

        if (!focalPosition) {
            return;
        }

        if (focalProperty === 'background-position') {
            $el.style.backgroundPosition = focalPosition;
            return;
        }

        $el.style.objectPosition = focalPosition;
    });
}
